import React from "react";
import { Button } from "@components/atoms/common/Button";
import { ButtonLink } from "@components/atoms/common/ButtonLink";

type ContactUIProps = {
  id?: string;
  title: string;
  href?: string;
  icon: string;
};

const TriggerChatSupport = () => {
  const ele = document.querySelector(".chatsupport-button") as HTMLElement;
  if (ele !== undefined) {
    ele.click();
  }
};

const handleClick = (event: React.MouseEvent, id: string | unknown): void => {
  if (id === "start-chat-btn") {
    event.preventDefault();
    TriggerChatSupport();
  }
};

export default function ContactUI({ data }: { data: ContactUIProps[] }) {
  return (
    <>
      <div className="contact-section fx--ch">
        {data.map((item: ContactUIProps, index) => {
          if ("href" in item) {
            return (
              <ButtonLink id={item.id} href={item.href} key={index}>
                <figure
                  className="md:d-none"
                  dangerouslySetInnerHTML={{ __html: item.icon }}
                ></figure>
                <span className="fw-600 ml-2 text-md">{item.title}</span>
              </ButtonLink>
            );
          } else {
            return (
              <Button
                id={item.id}
                onClick={(e) => {
                  handleClick(e, item.id);
                }}
                key={index}
              >
                <figure
                  className="md:d-none"
                  dangerouslySetInnerHTML={{ __html: item.icon }}
                ></figure>
                <span className="fw-600 ml-2 text-md">{item.title}</span>
              </Button>
            );
          }
        })}
        <style jsx>{`
          .contact-section {
            margin: auto;
          }
        `}</style>
      </div>
    </>
  );
}
